export default {
    'driverPerformanceFunctionTab_intervention_intervention': 'Intervention',
    'driverPerformanceFunctionTab_intervention_enableIntervention': 'Enable Intervention',
    'driverPerformanceFunctionTab_intervention_riskEvent': 'Risk Events',
    'driverPerformanceFunctionTab_intervention_category': 'Category',
    'driverPerformanceFunctionTab_intervention_eventName': 'Event name',
    'driverPerformanceFunctionTab_intervention_severity': 'Severity',
    'driverPerformanceFunctionTab_intervention_assignedEvents': 'Assigned Events',
    'driverPerformanceFunctionTab_intervention_noEventsAssigned': 'No events assigned yet',
    'driverPerformanceFunctionTab_intervention_eventsLoaded': '{loaded} of {total} events loaded',
    'driverPerformanceFunctionTab_intervention_interventionEventRequired': 'At least one intervention event is required when intervention is enabled',
    'driverPerformanceFunctionTab_intervention_updatedConfiguration': 'Configuration Saved Successfully',
    'driverPerformanceFunctionTab_intervention_updatedConfigurationError': 'Error Saving Configuration',
    'driverPerformanceFunctionTab_intervention_coachingEducationRequired': 'Coaching Education must be enabled before activating Intervention',
    'driverPerformanceFunctionTab_intervention_severityTooltip': 'Severity range: 1-100',
    'driverPerformanceFunctionTab_intervention_selectProfile': 'Select Profile',

    // Event category translations
    'eventCategory_aggression': 'Aggression',
    'eventCategory_adas': 'ADAS',
    'eventCategory_dms': 'DMS',

    // Event translations
    'event_power_lost': 'Power Lost',
    'event_rapid_acceleration': 'Rapid Acceleration',
    'event_hard_brake': 'Hard Brake',
    'event_potential_incident': 'Potential Incident',
    'event_speed_threshold': 'Speed Threshold',
    'event_hard_turn': 'Hard Turn',
    'event_collision_warning': 'Collision Warning',
    'event_close_following': 'Close Following',
    'event_tailgating': 'Tailgating',
    'event_asleep': 'Asleep',
    'event_yawn': 'Yawn',
    'event_drowsiness': 'Drowsiness',
    'event_using_phone': 'Using Phone',
    'event_distracted': 'Distracted',
    'event_smoking': 'Smoking',
    'event_no_seatbelt': 'No Seatbelt',
    'event_manual': 'Manual',
    'event_stop_sign_violation': 'Stop Sign Violation',
    'event_camera_obstructed': 'Camera Obstructed',
    'event_idle_no_driver': 'Idle No Driver',
    'event_lane_departure': 'Lane Departure',
    'event_posted_speed': 'Posted Speed',
    'event_pedestrian_detection': 'Pedestrian Detection',
    'event_cyclist_warning': 'Cyclist Warning',
    'event_passenger_inside': 'Passenger Inside',
    'event_passenger_seatbelt': 'Passenger Seatbelt',
    'event_unassigned_driver': 'Unassigned Driver',
    'event_parking_hit': 'Parking Hit',
    'event_sdcarderror': 'SDCardError'
};
